var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Logo'),_c('div',[(_vm.prod)?_c('code',[_vm._v(_vm._s(_vm.version))]):_c('code',[_vm._v("Development")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }